import { WorkflowDesktopView } from './WorkflowDesktopView';

export function WorkflowMobileView() {
  return <WorkflowDesktopView mode="mobile" />;
}
